export default "__VITE_ASSET__DkmL5xF___"